import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';
import { CommercialOperationDate } from '@price-card/models/commercial-operation-date.model';

export interface CommercialOperationDatesState {
  commercialOperationDates: CommercialOperationDate[];
  isFetching: boolean;
  error?: string;
}

const initialState: CommercialOperationDatesState = {
  commercialOperationDates: [],
  isFetching: false,
};

export const commercialOperationDatesSlice = createSlice({
  name: 'commercialOperationDates',
  initialState,
  reducers: {
    retrieveCommercialOperationDates: state => {
      state.isFetching = true;
    },
    retrieveCommercialOperationDatesSuccess: (state, action: PayloadAction<CommercialOperationDate[]>) => {
      state.commercialOperationDates = [...action.payload].sort((a, b) => b.year - a.year);
      state.isFetching = false;
    },
    retrieveCommercialOperationDatesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export type CommercialOperationDatesViewModel = {
  commercialOperationDates: CommercialOperationDate[];
  isFetching: boolean;
  error?: string;
};

export const selectCommercialOperationDatesViewModel = createSelector(
  (state: RootState) => state,
  (state): CommercialOperationDatesViewModel => ({
    commercialOperationDates: state.priceCard.commercialOperationDates.commercialOperationDates,
    isFetching: state.priceCard.commercialOperationDates.isFetching,
    error: state.priceCard.commercialOperationDates.error,
  }),
);
export const { retrieveCommercialOperationDates, retrieveCommercialOperationDatesSuccess, retrieveCommercialOperationDatesFailure } =
  commercialOperationDatesSlice.actions;

export default commercialOperationDatesSlice.reducer;
